<script lang="ts" module>
  import type { ISbResult } from "@storyblok/svelte";
  import { PUBLIC_BRAND_SLUG } from '$env/static/public';

  export interface FooterProps {
    footerData: ISbResult['data'];
  }
</script>

<script lang="ts">
  import { Footer } from "@agapi/ui/footer";
  import { StoryblokComponent, useStoryblokBridge } from "@storyblok/svelte";
  import { getStoryblokApi } from "@storyblok/svelte";
  import { browser } from "$app/environment";

  const { footerData }: FooterProps = $props();

  let story: ISbResult['data'] = $state(null);
  const isPreview = browser && new URLSearchParams(window.location.search).has('_storyblok');

  $effect.pre(() => {
    if (isPreview) {
      const loadStory = async () => {
        const storyblokApi = getStoryblokApi();
        const { data } = await storyblokApi.get(`cdn/stories/${PUBLIC_BRAND_SLUG}/footer`, {
          version: "draft",
        });
        story = data.story.content.content;
        useStoryblokBridge(data.story.id, (newStory) => (story = newStory.content.content), { preventClicks: true });
      };
      loadStory();
    }
  });
</script>

<Footer colorVariant={footerData.colorVariant} css={{ overflowAnchor: 'none' }}>
  {#if isPreview && story}
    <StoryblokComponent blok={story} />
  {:else if footerData.content?.length > 0}
    {#each footerData.content as row}
      <StoryblokComponent blok={row} />
    {/each}
  {/if}
</Footer>
